/**
 * Plan-gone detection for Tx Presenter: the treatment plan this page was opened on no longer
 * exists in Open Dental (the office deleted or re-saved it while a tab was still open).
 *
 * Keep this IMPORT-FREE — cypress/node-tests/tx-plan-gone.test.js executes this exact file.
 *
 * WHY TWO SHAPES. Since 2026-11-04 the backend answers a missing plan with a QUIET HTTP 200
 * `{ success:false, error:'PLAN_NOT_FOUND', message }` (Lumigo pages Slack on any 4xx a traced
 * handler returns, so the old 404 woke people up for an ordinary office event — see
 * teamio-serverless-api/tx-presenter-service PROJECT_NOTES.md). Before that deploy it was a
 * 404. This repo and that one deploy in either order, so the frontend accepts BOTH:
 *   - isPlanGoneResponse(data)  — the new 200 body (what axios resolves with `.data`)
 *   - isPlanGoneError(err)      — a thrown error: our own flagged Error, the OLD 404, or an
 *                                 error body that carries the code
 * Callers key on the code, never on message text.
 */

export const PLAN_NOT_FOUND = 'PLAN_NOT_FOUND';

/** True for the backend's quiet-200 "this plan no longer exists" body. */
export function isPlanGoneResponse(data) {
  return !!data && data.success === false && data.error === PLAN_NOT_FOUND;
}

/**
 * True when a thrown error means the plan is gone: our own Error flagged `planGone` (thrown by
 * the store when it sees the quiet-200 body), the OLD backend's 404, or an error response body
 * carrying the code. A network error or a 500 is NOT plan-gone — those keep their own handling.
 */
export function isPlanGoneError(err) {
  if (!err) return false;
  if (err.planGone === true) return true;
  const res = err.response;
  if (res && res.status === 404) return true;
  return !!(res && res.data && res.data.error === PLAN_NOT_FOUND);
}
